<template>
    <div class="left_1">
                   <!-- <div class="span">
                        <span>patientId</span>
                        <span>{{ $store.getters.getUserInfo.patientId? $store.getters.getUserInfo.patientId:'N/A' }}</span>
                   </div> -->
                   <div class="span">
                        <span>name</span>
                        <span>{{ $store.getters.getUserInfo.name? $store.getters.getUserInfo.name:'N/A' }}</span>
                    </div>
                    <div class="span">
                        <span>birth date</span>
                        <span>{{ $store.getters.getUserInfo.birthDate?$store.getters.getUserInfo.birthDate :'N/A'}}</span>
                    </div>
                    <div class="span">
                        <span>sex</span>
                        <span>{{ $store.getters.getUserInfo.sex?$store.getters.getUserInfo.sex :'N/A'}}</span>
                    </div>
                    <div class="span">
                        <span>laterality</span>
                        <span>{{ $store.getters.getUserInfo.laterality?$store.getters.getUserInfo.laterality:'N/A' }}</span>
                    </div>
                    <div class="span">
                        <span>ID</span>
                        <span>{{ $store.getters.getUserInfo.ID?$store.getters.getUserInfo.ID:'N/A' }}</span>
                    </div>
                    <div class="span">
                        <span>scan date</span>
                        <span>{{ $store.getters.getUserInfo.scanDate?$store.getters.getUserInfo.scanDate:'N/A' }}</span>
                    </div>
    </div>
</template>

<script>

export default {
  name: 'userInfo',
  props: {
    // userInfo: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  data () {
    return {
      userInfo: {}
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.left_1{
    // border-bottom: 1px solid;
    // margin-top: -35px;
     .span{
        display: flex;
        justify-content: space-between;
         padding: 0.3rem 0;
         font-size: 16px;
        color: #2A2A2A;
     }
   }
   @media screen and (min-height:1200px){
    // padding: 10px 0;
    padding: 0.5rem 0;
    .left_1{
      margin-top: -35px;
    }
   }
   @media screen and (max-width:1440px){
    .left_1 .span{
      font-size: 16px;
    }
   }
   @media screen and (min-width:1441px) and (max-width:1680px){
    .left_1 .span{
      font-size: 18px;
    }
   }
   @media screen and (min-width:1681px){
    .left_1 .span{
      font-size: 18px;
    }
   }
</style>
